<script>
export const group = 'Bottom'
</script>

<script setup>
import { onMounted } from 'vue'
import JOEPhoneIn from '../../../assets/animations/joe/joe_phone_in.webm'
import JOEPhoneOut from '../../../assets/animations/joe/joe_phone_out.webm'
import SlidingPill from './elements/SlidingPill.vue'
const gsapTimeline = useGsapTimeline()
const { item } = defineProps({
  item: Object,
})

const showIn = ref(true)
const showOut = ref(false)
const videoIn = ref(null)
const videoOut = ref(null)

const slidingPillTimeline = ref(null)
const slidingPillTimelineOut = ref(null)

const videoInResetAndPlay = () => {
  videoIn.value.currentTime = 0
  videoIn.value.play()
}

onMounted(() => {
  gsapTimeline({ name: 'PhoneCallSmall' })
    .to({}, { onComplete: () => videoInResetAndPlay(), duration: 0 })
    .add(slidingPillTimeline, frames(43, 50))
})

const { onDisappear } = useDisappearable()
onDisappear(async () => {
  showOut.value = true
  showIn.value = false

  if (slidingPillTimelineOut.value) {
    gsapTimeline({ name: 'PhoneCallSmall - Out' }).add(slidingPillTimelineOut.value())
  }

  videoOut.value.play()
  await new Promise((resolve) => videoOut.value.addEventListener('ended', resolve))
})

const callContactName = computed(() => item.enrichment.callContact?.name)
</script>

<template>
  <VideoPlayer v-show="showIn" class="absolute bottom-0 left-0" :src="JOEPhoneIn" muted @videoElement="videoIn = $event" />
  <VideoPlayer v-show="showOut" class="absolute bottom-0 left-0" :src="JOEPhoneOut" muted @videoElement="videoOut = $event" />
  <SlidingPill
    v-if="callContactName"
    :key="callContactName"
    class="absolute left-[240px] bottom-[192px]"
    :text="callContactName"
    @timeline="slidingPillTimeline = $event"
    @timelineOut="slidingPillTimelineOut = $event"
  />
</template>
